export default __webpack_public_path__ + "static/media/aae128c32ea232e51a55c4b0de185313.f9e3e5f5.png";